import SearchIcon from '@mui/icons-material/Search';
import {
  Box,
  Button,
  IconButton,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableFooter,
  TableHead,
  TablePagination,
  TableRow,
  TextField,
  Typography
} from '@mui/material'
import { useEffect } from 'react';
import { Link } from 'react-router-dom'
import { customerSearch } from '../../api/customersAPI';
import useSearchPagination from '../../hooks/useSearchPagination';
import { formatPhoneNum } from "../../utils/phoneUtils";
import NavBar from '../layout/NavBar';

function CustomerSearch() {
  const {
    query, setQuery, result, setResult, page, rowsPerPage, handleChangePage, handleChangeRowsPerPage
  } = useSearchPagination();

  async function searchCustomers(e) {
    if (e) {
      e.preventDefault()
    }

    let searchQuery = document.getElementById('customer-query').value
    setQuery(searchQuery);

    try {
      const response = await customerSearch(searchQuery);
      const customers = response.data;
      console.log(`Searched for: ${searchQuery ? `"${searchQuery}"` : 'All Customers'} (${customers.length} found)`);
      setResult(customers)
    } catch (error) {
      setResult([]);
      console.error(error);
    }
  }

  useEffect(() => {
    (async () => {
      await searchCustomers(null);
    })();
  }, []);

  return (
    <Box sx={{
      textAlign: 'center',
      minWidth: '519px',
      maxWidth: '75%',
      margin: 'auto' }}
    >
      <form className='search-form'>
        <TextField label='Customer Search' id='customer-query' fullWidth />
        <IconButton type='submit' onClick={searchCustomers} sx={{ ml: .5, borderRadius: 1}}>
          <SearchIcon sx={{ fontSize: 41 }} />
        </IconButton>
      </form>
      <Link to='/customers/add' style={{ textDecoration: 'none' }}>
        <Button variant='contained' sx={{ my: 1}} >Add Customer</Button>
      </Link>

      <Box id='results'>
        <Typography variant='h4'>Results</Typography>
        <Typography>Searching for {query ? `"${query}"` : 'all customers'}</Typography>
        <TableContainer container={Paper} sx={{ textAlign: 'center' }}>
          <Table>
            <TableHead>
              <TableRow>
                <TableCell>First</TableCell>
                <TableCell>Last</TableCell>
                <TableCell>Phone</TableCell>
                <TableCell>Vehicles</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {(rowsPerPage > 0
                ? result.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                : result
              ).map(customer => (
                <TableRow key={customer.id}>
                  <TableCell><Link to={'/customers/' + customer.id}>{customer.first_name}</Link></TableCell>
                  <TableCell><Link to={'/customers/' + customer.id}>{customer.last_name}</Link></TableCell>
                  <TableCell><Link to={'/customers/' + customer.id}>{formatPhoneNum(customer.phone)}</Link></TableCell>
                  <TableCell><Link to={'/customers/' + customer.id}>{customer.vehicles.length}</Link></TableCell>
                </TableRow>
              ))}
            </TableBody>
            <TableFooter>
              <TableRow>
                <TablePagination
                  rowsPerPageOptions={[5, 10, 25, { label: 'All', value: -1 }]}
                  count={result.length}
                  rowsPerPage={rowsPerPage}
                  page={page}
                  slotProps={{
                    select: {
                      inputProps: {
                        'aria-label': 'rows per page',
                      },
                      native: true,
                    },
                  }}
                  onPageChange={handleChangePage}
                  onRowsPerPageChange={handleChangeRowsPerPage}
                />
              </TableRow>
            </TableFooter>
          </Table>
        </TableContainer>
      </Box>
    </Box>
  );
}

export default function Customers() {
  return (
    <Box>
      <Typography variant='h2' align='center'>Customers</Typography>
      <NavBar active='Customers' />
      <CustomerSearch />
    </Box>
  );
}